import { render } from "./TDCreate.vue?vue&type=template&id=54309807"
import script from "./TDCreate.vue?vue&type=script&lang=js"
export * from "./TDCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__